import { ComponentProps } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { Input } from '@/components/core/input';

import { DefaultFormField, FormFieldProps } from './default-form-field';

type NumberInputProps = Omit<ComponentProps<typeof Input>, 'type' | 'value' | 'onChange'>;

export function NumberFormField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  description,
  disabled,
  hideError,
  label,
  name,
  ...props
}: FormFieldProps<NumberInputProps, TFieldValues, TName>) {
  return (
    <DefaultFormField
      control={control}
      description={description}
      disabled={disabled}
      hideError={hideError}
      label={label}
      name={name}
      render={({ field }) => (
        <Input
          {...field}
          {...props}
          type="number"
          value={field.value ?? ''}
          onChange={(e) => {
            const { value } = e.currentTarget;
            field.onChange(value === '' ? null : e.currentTarget.valueAsNumber);
          }}
        />
      )}
    />
  );
}
